// Add your custom JS here.
jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 50) {
        jQuery('header.header-site').addClass('scrolled');
    } else {
        jQuery('header.header-site').removeClass('scrolled');
    }
});

jQuery(document).ready(function ($) {
    AOS.init({
        offset: 80,
    });
});

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            $(this).click();
        }
    });

    get_size_nav();
    jQuery(window).on("resize", function () {
        get_size_nav();
    });

    function get_size_nav() {
        const alturaNavTopConBorder = jQuery(".nav-top").outerHeight();
        let marginTop = alturaNavTopConBorder;


        if ($("#wpadminbar").length) {
            marginTop += $("#wpadminbar").outerHeight();
        }

        jQuery("#wrapper-navbar").css("margin-top", marginTop + "px");
    }

    // content-video
    const videos = document.querySelectorAll('.content-video');

    videos.forEach(videoContainer => {
        const type = videoContainer.dataset.type;
        const playButton = videoContainer.querySelector('.video-play');

        if (type === 'file') {
            const video = videoContainer.querySelector('video');

            playButton.addEventListener('click', () => {
                video.play();
                playButton.style.display = 'none';
            });

            video.addEventListener('play', () => {
                playButton.style.display = 'none';
            });
        }

        if (type === 'embed' || type === 'script') {
            const iframe = videoContainer.querySelector('iframe');
            if (!iframe) return;

            const src = iframe.src;
            iframe.src = src.includes('?') ? `${src}&enablejsapi=1` : `${src}?enablejsapi=1`;

            playButton.addEventListener('click', () => {
                iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                playButton.style.display = 'none';
            });
        }
    });

    // slider gallery
    const galleries = $('.content-gallery');
    galleries.each(function() {
        const gallery = $(this);
        gallery.slick({
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<div class="slick-arrow slick-prev default-arrow"></div>',
            nextArrow: '<div class="slick-arrow slick-next default-arrow"></div>'
        });

        gallery.closest('.content-gallery-module').find('.arrow-custom-prev').on('click', function () {
            gallery.slick('slickPrev')
        });
    
        gallery.closest('.content-gallery-module').find('.arrow-custom-next').on('click', function () {
            gallery.slick('slickNext');
        });
    });

});

/*skip content*/
document.addEventListener('DOMContentLoaded', function () {
    const LinkGoSecondSection = document.getElementById('GoSecondSection');
    LinkGoSecondSection.addEventListener('click', function (event) {
        event.preventDefault();
        const secondSection = document.querySelector('.general-section:nth-of-type(2)');
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: 'smooth' });
        } else {
            console.error('the second section was not found.');
        }
    });

    // process tabs
    const $processButtons = document.querySelectorAll('.process-button');
    const $processTabs = document.querySelectorAll('.process-tab');
    if ($processButtons.length > 0 && $processTabs.length > 0) {
        $processButtons[0].classList.add('active');
        $processTabs[0].classList.add('active');
    }

    $processButtons.forEach((button, index) => {
        button.addEventListener('click', function (event) {
            event.preventDefault();
            const targetTab = button.getAttribute('data-tab');

            $processButtons.forEach((btn) => btn.classList.remove('active'));
            $processTabs.forEach((tab) => tab.classList.remove('active'));

            button.classList.add('active');
            const matchingTab = document.querySelector(`.process-tab[data-tab="${targetTab}"]`);
            if (matchingTab) {
                matchingTab.classList.add('active');
            }
        });
    });

});



function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = 'height:auto; padding:0';
        el.style.cssText = 'height:' + (el.scrollHeight + 2) + 'px';
    }, 0);
}
